import React, { useCallback, useEffect, useState } from "react"
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps"

export default function GoogleMap({ lat = 20, lng = 50, zoom = 12, apiKey = "", style = {}, markers = null }) {
	const [cameraProps, setCameraProps] = useState({ center: { lat, lng }, zoom })

	const handleCameraChange = useCallback((ev) => setCameraProps(ev.detail), [])

	useEffect(() => {
		setCameraProps({ ...cameraProps, center: { lat, lng }, zoom })
	}, [lat, lng, zoom])

	return (
		<APIProvider apiKey={apiKey}>
			<Map onCameraChanged={handleCameraChange} style={style} disableDefaultUI={true} {...cameraProps}>
				{Array.isArray(markers) ? (
					markers.map((marker, index) => <Marker key={index} position={{ lat, lng }} />)
				) : (
					<Marker position={markers || { lat, lng }} />
				)}
			</Map>
		</APIProvider>
	)
}
